<top-banner variant="custom">
    <h2 class="title mb-3" *ngIf="selectedContractor">{{ selectedContractor.name }}</h2>
    <button type="button" (click)="toggleAddWorkerModal()" class="btn color_blue-btn btn-round">
      <i class="fas fa-plus"></i>
      &nbsp;
      <strong>ADD NEW CONTRACTOR WORKER</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <h4 class="card-title">Workers</h4>
            <div class="mb-2 animated fadeIn">
              <div class="form-row">
                <!-- Search and Sorting/Filter sidemenu button to be implemented here -->
                <div class="col-md-9">
                  <select class="form-control my-3" style="width: auto" [(ngModel)]="selectedSort" (ngModelChange)="sortChange($event)">
                    <option *ngFor="let option of sortFields" [ngValue]="option">
                      {{ option.sortName }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3"></div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="users" selectionMode="single" [(selection)]="selectedUser" (onRowSelect)="onRowSelect($event)" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="table-cell-centered">Activated</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Login</th>
                        <th>Contact No.</th>
                        <th>Site delegate</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-user>
                      <tr [pSelectableRow]="user">
                        <td class="table-cell-centered">
                          <i *ngIf="user.activated" class="fas fa-check-circle success"></i>
                          <i *ngIf="!user.activated" class="fas fa-times-circle danger"></i>
                        </td>
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.login }}</td>
                        <td>{{ user.workerUser.phoneNumber }}</td>
                        <td>
                          <i *ngIf="user.isSiteDelegate" class="fas fa-check-circle success"></i>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="7">No workers found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="New Worker User" [(visible)]="createUserModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="createUserForm" (ngSubmit)="onCreateUserFormSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>First Name <span class="required-star">*</span></label>
          <input type="text" class="form-control" formControlName="firstName" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Last Name <span class="required-star">*</span></label>
          <input type="text" class="form-control" formControlName="lastName" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email <span class="required-star">*</span></label>
          <input type="email" class="form-control" formControlName="email" (input)="clearErrors()" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Phone Number <span class="required-star">*</span></label>
          <input type="text" class="form-control" formControlName="phoneNumber" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <hr>
        <div class="form-group">
          <label>Password <span class="required-star">*</span></label>
          <input type="password" autocomplete="new-password" class="form-control" (input)="clearErrors()" formControlName="pin" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <hr>
        <div class="form-group">
          <label>Repeat Password <span class="required-star">*</span></label>
          <input type="password" autocomplete="new-password" class="form-control" formControlName="rPin" (input)="clearErrors()" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="createUserModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onCreateUserFormSubmit()" [disabled]="!createUserForm.valid" class="my-2 btn btn-round btn-sm btn-success">Create</button>
  </p-footer>
</p-dialog>
